import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const FinePolicyList = Loadable(
  lazy(() => import("features/finePolicy/components/List"))
);
const FinePolicyPage = Loadable(
  lazy(() => import("features/finePolicy/components/Page"))
);

const routes = {
  path: "finePolicy",
  children: [
    { path: "", element: <FinePolicyList /> },
    { path: "add", element: <FinePolicyPage /> },
    { path: "edit/:lateFinePolicyID?", element: <FinePolicyPage /> },
  ],
};

export default routes;
